import {
  useGridApiContext,
  gridColumnDefinitionsSelector,
  gridColumnVisibilityModelSelector,
} from "@mui/x-data-grid";
import {
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
  Divider,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

const CustomColumnsPanel = () => {
  const apiRef = useGridApiContext();
  const { t } = useTranslation();

  // ✅ LẤY TẤT CẢ COLUMNS
  const columns = gridColumnDefinitionsSelector(apiRef);
  const visibilityModel = gridColumnVisibilityModelSelector(apiRef);

  const [search, setSearch] = useState("");

  const filteredColumns = useMemo(() => {
    return columns.filter((col) =>
      (col.headerName || col.field)
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  }, [columns, search]);

  const isColumnVisible = (field) => visibilityModel[field] ?? true;

  const toggleColumn = (field) => {
    apiRef.current.setColumnVisibility(field, !isColumnVisible(field));
  };

  const allVisible = columns.every((col) => isColumnVisible(col.field));

  const toggleAll = () => {
    if (allVisible) {
      // 🔴 Hide all
      const newModel = {};
      columns.forEach((col) => {
        newModel[col.field] = false;
      });
      apiRef.current.setColumnVisibilityModel(newModel);
    } else {
      // 🟢 Show all (reset về mặc định)
      apiRef.current.setColumnVisibilityModel({});
    }
  };

  const reset = () => {
    apiRef.current.setColumnVisibilityModel({});
  };

  return (
    <Box sx={{ width: 300, p: 2 }}>
      <TextField
        size="small"
        fullWidth
        placeholder={t("common.search")}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={{
          startAdornment: <SearchIcon fontSize="small" sx={{ mr: 1 }} />,
        }}
        sx={{ mb: 1 }}
      />

      <Box sx={{ maxHeight: 280, overflowY: "auto" }}>
        {filteredColumns.map((col) => (
          <FormControlLabel
            key={col.field}
            sx={{ display: "flex", pl: 0.5 }}
            control={
              <Checkbox
                size="small"
                checked={isColumnVisible(col.field)}
                onChange={() => toggleColumn(col.field)}
              />
            }
            label={col.headerName || col.field}
          />
        ))}
      </Box>

      <Divider sx={{ my: 1 }} />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 0.5,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={allVisible}
              indeterminate={!allVisible}
              onChange={toggleAll}
            />
          }
          label={t("common.content-056")}
        />

        <Typography
          variant="body2"
          sx={{
            color: "primary.main",
            cursor: "pointer",
            opacity: 0.8,
            "&:hover": { opacity: 1 },
          }}
          onClick={reset}
        >
          {t("button.reset")}
        </Typography>
      </Box>
    </Box>
  );
};

export default CustomColumnsPanel;
